var SENTRY_RELEASE;SENTRY_RELEASE={name: "tago", version: "2.0.1"};